<template>
  <div class="registers flex f-center f-end">
    <!-- 手机注册 -->
    <div class="logins">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="手机注册" name="first">
          <div class="inputs" v-if="tabId == 0">
            <el-input
              autocomplete="off"
              v-model="phonename"
              type="text"
              @input="pname"
              prefix-icon="el-icon-user"
              placeholder="请输入姓名"
            ></el-input>
            <el-input
              autocomplete="off"
              v-model="phonenumber"
              @input="pnumber"
              maxlength="11"
              placeholder="请输入手机号"
              prefix-icon="el-icon-phone-outline"
            ></el-input>
            <div class="verify">
              <el-input
                autocomplete="off"
                style="margin-top: 0px"
                @input="pcode"
                placeholder="请输入验证码"
                prefix-icon="el-icon-key"
                v-model="phonecode"
              ></el-input>
              <div
                @click.stop="sendSmsCode"
                class="zai-checking"
                v-if="state === false"
              >
                获取验证码
              </div>
              <div class="zai-checking zai-time" v-if="state === true">
                倒计时{{ currentTime }}s
              </div>
            </div>
            <!-- <el-input
              autocomplete="off"
              placeholder="请输入密码"
              @input="ppassword"
              show-password
              prefix-icon="el-icon-lock"
              v-model="phonepassword"
            ></el-input> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="邮箱注册" name="last">
          <div class="inputs" v-if="tabId == 1">
            <el-input
              autocomplete="off"
              v-model="emailname"
              type="text"
              prefix-icon="el-icon-user"
              placeholder="请输入姓名"
            ></el-input>
            <el-input
              autocomplete="off"
              v-model="emailnumber"
              placeholder="请输入邮箱"
              prefix-icon="el-icon-message"
            ></el-input>
            <el-input
              placeholder="请输入密码"
              show-password
              prefix-icon="el-icon-lock"
              v-model="emailpassword"
            ></el-input>
            <el-input
              placeholder="请确认密码"
              show-password
              prefix-icon="el-icon-lock"
              v-model="emailpassword2"
            ></el-input>
            <div class="verify">
              <el-input
                autocomplete="off"
                style="margin-top: 0px"
                placeholder="请输入验证码"
                prefix-icon="el-icon-key"
                v-model="emailcode"
              ></el-input>
              <div
                @click.stop="sendEmailCode"
                class="zai-checking"
                v-if="state === false"
              >
                获取验证码
              </div>
              <div class="zai-checking zai-time" v-if="state === true">
                倒计时{{ currentTime }}s
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="guide">
        <el-checkbox @change="guides" v-model="checked"></el-checkbox>
        我同意
        <span @click.stop="fu">《使用条款》</span>
      </div>
      <div @click="sub" class="register">提交</div>
      <div @click.stop="login()" class="zhu">账号登录</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.el-tabs__active-bar {
  background: #fb004d;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fb004d;
  border-color: #fb004d;
}
.registers {
  min-width: 1200px;
  position: relative;
  position: relative;
  background-image: url("../img/login_bg.png");
  background-size: cover;
  height: calc(
    100vh - 180px
  );
  .logins {
    width: 358px;
    max-height: 570px;
    padding-top: 17px;
    box-sizing: border-box;
    margin-right: 20%;
    background: #ffffff;
    z-index: 1;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    .find {
      text-align: center;
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(54, 64, 94, 1);
    }
    .el-tabs__nav-scroll {
      display: flex;
      margin-left: 50px;
    }
    .el-tabs__item {
      padding: 0 65px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
    }
    .is-active {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #fb004d;
    }
    .el-tabs__nav-wrap::after {
      background-color: #ffffff;
    }
    .inputs1{
      height: auto;
    }
    .inputs {
      width: 306px;
      margin: 10px auto 30px auto;
      .el-input__inner {
        border: none;
        border-radius: 0px;
        border-bottom: 1px solid #e6e6e6;
      }
      .el-input {
        margin-bottom: 20px;
      }
    }
    .forget {
      width: 306px;
      margin: 18px auto 40px auto;
      text-align: right;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
      cursor: pointer;
    }
    .guide {
      width: 306px;
      margin: 0px auto 9px auto;
      color: #fb004d;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      span {
        cursor: pointer;
        color: #fb004d;
      }
      .el-radio__label {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
      }
    }
    .register {
      width: 306px;
      height: 44px;
      margin: 0 auto;
      background: #fb004d;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
      cursor: pointer;
    }
    .zhu {
      cursor: pointer;
      width: 80px;
      height: 44px;
      margin: 0 auto 10px auto;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #fb004d;
      line-height: 44px;
      text-align: center;
    }
    .zhu:hover {
      color: red;
    }
    .verify {
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .el-input__inner {
        width: 60%;
      }
      .zai-checking {
        height: 40px;
        width: 40%;
        text-align: center;
        font-size: 14px;
        color: #fb004d;
        cursor: pointer;
      }
    }
  }
}

</style>

<style lang="scss">
.registers {
  .el-tabs__active-bar {
    background: #fb004d;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fb004d;
    border-color: #fb004d;
  }

  
  .el-tabs__nav-scroll {
        display: flex;
        margin-left: 50px;
      }
      .el-tabs__item {
        padding: 0 65px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
      }
      // el-tabs__item is-top is-active
      .is-active {
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #fb004d;
        // background: linear-gradient(90deg, rgba(49, 114, 255, 1) 0%, rgba(24, 144, 255, 1) 100%);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
      .el-tabs__nav-wrap::after {
        background-color: #ffffff;
      }

}

  </style>


<script>
import { getcodes, phoneregister, getEmailcodes } from "../api.js";
export default {
  name: "Register",
  components: {},
  data() {
    return {
      fetch_static: false,
      fetch_statics: false, //邮箱
      activeName: "first",
      phonename: "", //手机注册姓名
      phonenumber: "", //手机注册手机号
      phonecode: "", //手机注册验证码
      phonepassword: "", //手机注册密码
      emailname: "", //邮箱注册姓名
      emailnumber: "", //邮箱地址
      emailcode: "", //邮箱验证码
      emailpassword: "", //邮箱注册密码
      emailpassword2: "", //邮箱注册确认密码
      input2: "",
      checked: true,
      echecked: true,
      state: false, //是否开启倒计时
      totalTime: 120, //总时间，单位秒
      recordingTime: 0, //记录时间变量
      currentTime: 0, //显示时间变量
      states: false, //是否开启倒计时
      totalTimes: 60, //总时间，单位秒
      recordingTimes: 0, //记录时间变量
      currentTimes: 0, //显示时间变量
      tabId: 0,
    };
  },
  methods: {
    handleClick(tab) {
      // console.log(tab, event);
      this.tabId = tab.index;
      //停止验证码倒计时
      this.state = false;
      this.checkingTime();
    },
    login() {
      this.$router.push("/login");
    },
    //手机注册获取姓名
    pname(e) {
      this.phonename = e;
      this.fetch_static = false;
    },

    //手机注册获取手机号
    pnumber(e) {
      this.phonenumber = e;
      this.fetch_static = false;
    },

    // 手机注册获取验证码
    pcode(e) {
      this.phonehonecode = e;
      this.fetch_static = false;
    },
    // 邮箱验证码
    ecode(e) {
      this.emailcode = e;
      this.fetch_statics = false;
    },
    //手机注册密码
    ppassword(e) {
      this.phonepassword = e;
      this.fetch_static = false;
    },
    // 邮箱注册密码
    epassword(e) {
      this.emailpassword = e;
      this.fetch_statics = false;
    },
    // 手机注册条款
    guides(e) {
      this.checked = e;
      this.fetch_static = false;
    },

    // 手机号计时
    checkingTime() {
      let that = this;
      //判断是否开启
      if (this.state) {
        //判断显示时间是否已到0，判断记录时间是否已到总时间
        if (this.currentTime > 0 && this.recordingTime <= this.totalTime) {
          //记录时间增加 1
          this.recordingTime = this.recordingTime + 1;
          //显示时间，用总时间 - 记录时间
          this.currentTime = this.totalTime - this.recordingTime;
          //1秒钟后，再次执行本方法
          setTimeout(() => {
            //定时器内，this指向外部，找不到vue的方法，所以，需要用that变量。
            that.checkingTime();
          }, 1000);
        } else {
          //时间已完成，还原相关变量
          this.state = false; //关闭倒计时
          this.recordingTime = 0; //记录时间为0
          this.currentTime = this.totalTime; //显示时间为总时间
        }
      } else {
        //倒计时未开启，初始化默认变量
        this.state = false;
        this.recordingTime = 0;
        this.currentTime = this.totalTime;
      }
    },

    // 手机短信验证码
    sendSmsCode() {
      let that = this;
      let phone = that.phonenumber;
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (phone.length < 1) {
        that.$message.error("请填写手机号");
        return;
      } else if (!reg.test(phone)) {
        that.$message.error("手机格式不正确！");
        return;
      }
      let phones = { Phone: phone, Source: "pc", Type: "2" };
      getcodes(phones).then((res) => {
        if (res.data.Code == 0) {
          that.$message({
            message: res.data.Data,
            type: "success",
          });
          // 把显示时间设为总时间
          that.currentTime = that.totalTime;
          //开始倒计时
          that.state = true;
          //执行倒计时
          that.checkingTime();
        } else {
          that.$message.error(res.data.Message);
        }
      });
    },

    // 获取邮箱验证码
    sendEmailCode() {
      let that = this;
      let emailnumber = that.emailnumber;
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (emailnumber.length < 1) {
        that.$message.error("请填写邮箱");
        return;
      } else if (!reg.test(emailnumber)) {
        that.$message.error("邮箱格式不正确！");
        return;
      }
      let email = { Email: emailnumber, Source: "pc", Type: "2" };
      getEmailcodes(email).then((res) => {
        if (res.data.Code == 0) {
          that.$message({
            message: res.data.Data,
            type: "success",
          });
          // 把显示时间设为总时间
          that.currentTime = that.totalTime;
          //开始倒计时
          that.state = true;
          //执行倒计时
          that.checkingTime();
        } else {
          that.$message.error(res.data.Message);
        }
      });
    },

    // 提交手机注册
    sub() {
      let that = this;
      let datas = null;
      if (that.tabId == 0) {
        let phonename = that.phonename;
        let phonenumber = that.phonenumber;
        let phonehonecode = that.phonehonecode;
        let phonepassword = that.phonepassword;
        if (phonename == "") {
          that.$message.error("请填写姓名");
          return;
        }
        if (phonenumber == "") {
          that.$message.error("请填写手机号");
          return;
        }
        if (phonehonecode == "") {
          that.$message.error("请填写验证码");
          return;
        }
        if (!that.checked) {
          that.$message.error("请勾选服务条款");
          return;
        }

        datas = {
          Source: "web",

          Phone: phonenumber,
          Code: phonehonecode,
          Name: phonename,
          Password: phonepassword,
          RegType: "1",
        };
      }
      if (that.tabId == 1) {
        let emailname = that.emailname;
        let emailnumber = that.emailnumber;
        let emailpassword = that.emailpassword;
        let emailpassword2 = that.emailpassword2;
        let emailcode = that.emailcode;
        if (emailname == "") {
          that.$message.error("请填写姓名");
          return;
        }
        let reg =/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (emailnumber.length < 1) {
          that.$message.error("请填写邮箱");
          return;
        } else if (!reg.test(emailnumber)) {
          that.$message.error("邮箱格式不正确！");
          return;
        }
        if (emailpassword == "" || emailpassword2== "") {
          that.$message.error("请填写密码");
          return;
        }
        if (emailpassword != emailpassword2) {
          that.$message.error("两次密码不一致！");
          return;
        }
        if (emailcode == "") {
          that.$message.error("请填写验证码");
          return;
        }
        if (!that.checked) {
          that.$message.error("请勾选服务条款");
          return;
        }
        datas = {
          Source: "web",
          Name: emailname,
          Email:emailnumber,
          Code: emailcode,
          Password: emailpassword,
          RegType: "2",
        };

      }

      phoneregister(datas)
        .then((res) => {
          if (res.data.Code == 0) {
            that.fetch_static = true;
            localStorage.setItem("AccessToken", res.data.Data.AccessToken);
            localStorage.setItem("RefreshToken", res.data.Data.RefreshToken);
            localStorage.setItem(
              "AccessTokenTime",
              res.data.Data.AccessTokenTime
            );
            localStorage.setItem(
              "RefreshTokenTime",
              res.data.Data.RefreshTokenTime
            );
            //短信登录无需输入密码，所以隐藏
            // localStorage.setItem("phonenumber", phonenumber);
            // localStorage.setItem("password", phonepassword);
            localStorage.setItem("username", res.data.Data.MemberName);
            that.$message({
              message: "注册成功",
              type: "success",
            });

            setTimeout(() => {
              that.$router.push("/");
              // that.$router.push('/login');
            }, 500);
          } else {
            that.$message.error(res.data.Message);
            that.fetch_static = false;
          }
        })
        .catch((error) => {
          console.log(error);
          that.fetch_static = false;
        });
    },
    fu(){
      this.$router.push({path:'/page/service'})
    }
  },
};
</script>
